import React, { useEffect } from "react"
import { isEmpty, isEqual } from "lodash-es"
import { useDispatch, useSelector } from "react-redux"
import { initialize, answerOptionsLists as selectAnswerOptionsLists } from "reduxSlices/answerOptionsListsSlice"
import AnswerOptionsList from "./AnswerOptionsList"
import AddAnswerOptionsListButton from "./AddAnswerOptionsListButton"

const AnswerOptionsListIndex = () => {
  const dispatch = useDispatch()
  const allAnswerOptionsLists = useSelector(selectAnswerOptionsLists, isEqual)

  useEffect(() => {
    dispatch(initialize({}))
  }, [dispatch])

  return (
    <>
      {
        isEmpty(allAnswerOptionsLists) ? (
          <div>
            No answer options exist.
          </div>
        ) : (
          <div className="pl-0 mb-8">
            {
              allAnswerOptionsLists.map((answerOptionsList) => (
                <AnswerOptionsList
                  key={`answerOptionsList-${answerOptionsList.id}`}
                  answerOptionsList={answerOptionsList}
                />
              ))
            }
          </div>
        )
      }
      <div className="mt-6">
        <AddAnswerOptionsListButton />
      </div>
    </>
  )
}

export default AnswerOptionsListIndex
